import React from 'react'
import Footer from './Footer'
import wavy1 from '..//assets/wavy1.jpg'
import BlogPostCard from './BlogPostCard';
import blogImg1 from "../assets/blog-image-1.jpg"; 
import blogImg2 from "../assets/blog-image-2.jpg"; 
import blogImg3 from "../assets/blog-image-3.jpg"; 
import blogImg4 from "../assets/blog-image-4.jpg"; 
import blogImg5 from "../assets/blog-image-5.jpg"; 
import blogImg6 from "../assets/blog-image-6.jpg"; 
import blogImg7 from "../assets/blog-image-7.jpg"; 
import PrivacyBlog from './PrivacyBlog';
import PartnerTop from './PartnerTop';
import BlogSectionTop from './BlogSectionTop';

const BlogSection = () => {
  //    const sectionStyle = {
  //   height: '70vh',
  //   backgroundColor:'gray',
  //   display: 'flex',
  //   alignItems: 'flex-end',
  //   justifyContent: 'flex-start',
  //   textAlign: 'flex-end',
  //   overflowX: 'hidden' 
  // };

  // const textStyle = {
  //   color: '#00c3ff', // Bright blue color
  //   fontWeight: '700',
  //   fontSize: 'clamp(1.5rem, 5vw, 3.5rem)',
  //   lineHeight: '1.3',
  //   textShadow: '0 1px 2px rgba(0,0,0,0.4)'
  // };
  return (
    <div>
        {/* Hero Section of the Blog */}
         {/* <div  style={sectionStyle}>
      <h1 className='mx-5 mb-5' style={textStyle}>
        Software Development<br />
        Company in Delhi, India -<br />
        WARALS Technology
      </h1>
    </div> */}
    
    <BlogSectionTop largeHeading="WARALS Technology" smallHeading="Software Development Company in Delhi, India"  />
    <div className='container'>

       <PrivacyBlog/>
      {/* <BlogPostCard 
      smallHeading= "Blog • Uncategorized"
      largeHeading= "How a Learning Management System is Useful?"
      date= "November 11, 2020"
      author= "Admin"
      description= "LMS or Learning Management system is a software management system which is used to deliver educational
        courses and/or training programs to the customer base. <br/>It is a software which helps in creation, change,
        assigning, grading of programs which can help you easily organize the courses you plan to deliver to the
        students. For example, LMS..."
        upImage = {blogImg1}
        link = "https://blogs.warals.com/how-learning-management-system-is-useful/"
      /> */}
      
      <BlogPostCard 
      smallHeading= "Blog"
      largeHeading= "HOW INSTITUTE MANAGEMENT SYSTEM CAN HELP IN DATA SECURITY?"
      date= "November 03, 2020"
      author= "Admin"
      description= "With modernization, the educational and institutional system is getting computerized. With everything on the simple institute management system, one can get the learning material from a place at any time. However, the positive aspects come with the negative phase which includes the exploitation of personal info we allocate on such platforms. Your data can be..."
        upImage = {blogImg2}
        link = "https://blogs.warals.com/how-institute-management-system-can-help-in-data-security/"
      />
      <BlogPostCard 
      smallHeading= "Blog"
      largeHeading= "How Capable Is Google Meet For Live Online Classes?"
      date= "November 30, 2020"
      author= "Admin"
      description= "Due to the ongoing coronavirus pandemic crisis, 120 million students and educators all around the globe are using Google’s “G Suite for live online classes” to create, collaborate, and communicate for making the learning process accessible to all. Recently Google made their virtual meeting and collaboration platform “Google Meet” to work even better for schools..."
        upImage = {blogImg3}
        link = "https://blogs.warals.com/how-capable-is-google-meet-for-live-online-classes/"
      />
       <BlogPostCard 
      smallHeading= "Blog"
      largeHeading= "How An Institute Management System Can Help You?"
      date= "October 17, 2020"
      author= "Admin"
      description= "Wouldn’t it be great to have software which can manage all institutional activities ranging from exam scheduling to managing online admission, attendance, student progress, and much more? Sounds exciting no? The development will be a great help to manage subjects and courses easily. This Institute Management System helps in managing your institution without any hassle..."
        upImage = {blogImg4}
        link = "https://blogs.warals.com/how-an-institute-management-system-can-help-you/"
      />
       <BlogPostCard 
      smallHeading= "Blog"
      largeHeading= "Reasons Why Live Online Classes Have Become a Trend Around The Globe!"
      date= "October 09, 2020"
      author= "Admin"
      description= "It has been years now since the online teaching tools started penetrating the K12 market. Begun with free live online classes management software which let the tutors create lesson schedules and content for their subject topic to share with the students. Uploading video classes started lately with the availability of good internet. Now with the..."
        upImage = {blogImg5}
        link = "https://blogs.warals.com/reasons-why-live-online-classes-have-become-a-trend/"
      />
        <BlogPostCard 
      smallHeading= "Uncategorized"
      largeHeading= "Features of Warals School Management System"
      date= "September 22, 2020"
      author= "Admin"
      description= "A school management software helps in smooth functioning of a school and making various processes of schools convenient. It eases the task and various activities that a school performs like attendance management, fees management and many other. User Friendly Interface It’s an easy to use and well-defined interface. You don’t need to be a professional..."
        upImage = {blogImg6}
        link = "https://blogs.warals.com/features-of-warals-school-management-system/"
      />
         <BlogPostCard 
      smallHeading= "blog"
      largeHeading= "Why Is Learning Management System(LMS) Important Nowadays?"
      date= "September 22, 2020"
      author= "Admin"
      description= "Before the COVID-19 Pandemic, internet learning was viewed as a discretionary learning channel, an extravagance to be exact. As the lethal infection spread over the world, the Learning Management System has become an observer of the consistent blast. Also, with that, web-based learning turned into the favoured instruction medium. This rising fame of web-based learning..."
        upImage = {blogImg7}
        link = "https://blogs.warals.com/why-is-learning-management-systemlms-important-nowadays/"
      />

      {/* without Image part */}
      <BlogPostCard 
      smallHeading= "blog"
      largeHeading= "Institute Management Software: Effective Way to Manage Your Institutions"
      date= "September 21, 2020"
      author= "Admin"
      description= "Students, parents, teachers, and administrative decision-makers are the key participants when it comes to coaching institutes. Here’s how the Institute management software can benefit these stakeholders. A SINGLE DASHBOARD WITH INSIGHTS FROM MULTIPLE LOCATIONS The administrative team, managing coaching institutes with branches at many locations, often find it challenging to keep track of insights. Students’..."
        // upImage = {blogImg7}
        link = "https://blogs.warals.com/institute-management-software-effective-way-to-manage-your-institutions/"
      />
         <BlogPostCard 
      smallHeading= "blog"
      largeHeading= "10 Reasons Why School Management Software Is a Need?"
      date= "September 21, 2020"
      author= "Admin"
      description= "We are writing this article to address the reasons why the school management software is a need of every educational institution. As of now, there are several numbers of schools and institutions that have installed this software. In general, this software has efficiently managed the task of admins, teachers, staff, students and parents with a..."
        // upImage = {blogImg7}
        link= "https://blogs.warals.com/10-reasons-why-school-management-software-is-a-need/"
      />
         <BlogPostCard 
      smallHeading= "blog"
      largeHeading= "HOW LIVE ONLINE CLASSES HAS CHANGED THE WAY OF EDUCATION?"
      date= "September 21, 2020"
      author= "Admin"
      description= "The post-COVID phase is surely going to be a different one! There will be a visible change in behaviour and attitudes towards shopping, eating out and travelling throughout the globe. Governments across the globe have enforced lockdown and recommended that people should maintain social distancing measures to contain the further spread of the Corona virus..."
        // upImage = {blogImg7}
        link = "https://blogs.warals.com/how-live-online-classes-has-changed-the-way-of-education/"
      />
         <BlogPostCard 
      smallHeading= "blog"
      largeHeading= "5 PROBLEMS FACED DURING ONLINE CLASSES"
      date= "September 21, 2020"
      author= "Admin"
      description= "The world is facing the most significant public health crisis since the beginning of 2020. Coronavirus Pandemic has forced nearly all human beings to remain inside their homes, which is affecting their physical and mental health being. Not just inflicting this torment, this global crisis has also created a lot of fuss in everyone’s life...."
        // upImage = {blogImg7}
        link = "https://blogs.warals.com/5-problems-faced-during-online-classes/"
      />
    </div>
     
      <Footer/>
    </div>
  )
}

export default BlogSection
